import { Formik } from 'formik';
import { initialValuesFormInstitutions, validationSchemaFormInstitutionss } from './PersonalitiesInstitutionsFormValidator';
import Form from "./PersonalitiesInstitutionsForm";
import { useAxios } from '../../../context/AxiosHookContext';
import { useNotification } from '../../../context/NotificationContext';

const FormInstitutions = ({ valuesToEdit, onClose, getValues }) => {

    const axios = useAxios();
    const { showSnackbar } = useNotification();

    const handleSubmit = async (institution) => {

        try {

            if (institution._id) {
                await axios.put(`/personalities/organizations/update/${institution._id}`, institution)
            } else {
                await axios.post(`personalities/organizations/create`, institution )
            }

            showSnackbar({ severity: "success", title: "Guardado", message: "Se ha guardado la institución correctamente." });

            getValues();

        } catch (error) {
            const message = error?.response?.data?.message || error?.message || "Ha ocurrido un error al actualizar la institución."
            showSnackbar({ severity: "error", title: "Institución", message })
        }

    }

    const getInitialValues = () => {
        return (valuesToEdit && Object.keys(valuesToEdit).length) > 0 ? valuesToEdit : initialValuesFormInstitutions
    }
    return (
        <Formik
            validationSchema={validationSchemaFormInstitutionss}
            initialValues={getInitialValues()}
            onSubmit={handleSubmit}
        >
            <>
                <Form onClose={onClose} />
            </>
        </Formik>
    )
}

export { FormInstitutions }